import { type JSX } from 'react';

import { VIDEO_GENERATION_DURATION_OPTIONS } from '../../_context/constants';
import { AI_TOOLKIT_CATEGORIES, type AiToolkitCategory } from '../../_context/types';
import { SelectField, SelectFieldProps } from './SelectField';

export interface DurationSelectFieldProps extends Omit<SelectFieldProps, 'label' | 'id' | 'options' | 'defaultValue'> {
    aiToolkitCategory: Extract<AiToolkitCategory, 'video-generation' | 'voiceover'>;
}

export const DurationSelectField = ({
    aiToolkitCategory,
    selectTriggerProps,
    ...rest
}: DurationSelectFieldProps): JSX.Element => {
    const options =
        aiToolkitCategory === AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION ? VIDEO_GENERATION_DURATION_OPTIONS : [];

    return (
        <SelectField
            selectTriggerProps={{ name: 'duration', ...selectTriggerProps }}
            {...rest}
            label="Duration"
            id="duration"
            name="duration"
            options={options}
            defaultValue={options[0]?.value}
        />
    );
};
